/* eslint-disable no-console */
import Page from "@app/components/pageTypes/Page/Page"
import MyParadiseDataModal from "@app/modals/MyParadise/MyParadiseDataModal/MyParadiseDataModal"
import { useEffect } from "react"
import { useLocation } from "react-router"
import "./styles.css"

export default function AppDataPage() {
	const location = useLocation()

	useEffect(() => {
		if (location.pathname === "/myParadise") {
			console.log("push")
		}
	}, [location.pathname])

	return (
		<Page className="appdataPage">
			<MyParadiseDataModal />
		</Page>
	)
}
